import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import {
  NotificationContainer,
  NotificationManager as N,
} from 'react-notifications';

import api from '../../../../services/api';
import { fileUploadImg, fileUploadCatalogImg } from '../../../../services/s3';
import CatalogManagerContext from '../../CatalogManagerContext';

import ButtonLoader from '../../../../components/ButtonLoader';
import RatingView from '../../../../components/RatingView';

import 'react-notifications/lib/notifications.css';
import * as S from './styles';

const Image = ({ propData }) => {
  const { viewLoading, viewError, viewContent } = useContext(
    CatalogManagerContext
  );

  const [objDefault, setDefault] = useState({
    catThumbnailSquare: 'https://stingr-thumbnails-catalog.s3.amazonaws.com/public/catalogThumbnailSquare.png',
    catThumbnailBanner: 'https://stingr-thumbnails-catalog.s3.amazonaws.com/public/catalogThumbnailBanner.png',
  });
  const [objData, setData] = useState(propData);
  const [objTemp, setTemp] = useState({
    catThumbnailSquare: objData.catThumbnailSquare,
    catThumbnailBanner: objData.catThumbnailBanner,
  });
  // console.log(objData);

  const optStatus = [
    { id: 'Active', title: 'Active' },
    // { id: 'Processing', title: 'Processing' },
    { id: 'Disabled', title: 'Disabled' },
    // { id: 'Blocked', title: 'Blocked' },
  ];

  const handleCheckFiles = data => {
    console.log('#btn => Images -> Chek File');
    console.log(data);
  };

  const handleChangeFileSquare = async img => {
    console.log('#catThumbnailSquare => Upload -> Start');
    console.log(img);
    try {
      const fileUpload = await fileUploadImg(
        'CATALOG',
        objData.catId,
        'square',
        img[0]
      );
      console.log(fileUpload);

      // Validate Resolutions
      let comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 1024 || comImage.naturalHeight !== 1024) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            catThumbnailSquare: fileUpload.link,
          };
        });
        console.log('#catThumbnailSquare => Upload -> End');
      }
    } catch (e) {
      console.error(e);
      console.log('#catThumbnailSquare => Upload -> Error');
    }
  };

  const handleChangeFileBanner = async img => {
    console.log('#catThumbnailBanner => Upload -> Start');
    console.log(img);
    try {
      const fileUpload = await fileUploadImg(
        'CATALOG',
        objData.catId,
        'banner',
        img[0]
      );
      console.log(fileUpload);

      // Validate Resolutions
      let comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 1920 || comImage.naturalHeight !== 480) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            catThumbnailBanner: fileUpload.link,
          };
        });
        console.log('#catThumbnailBanner => Upload -> End');
      }
    } catch (e) {
      console.error(e);
      console.log('#catThumbnailBanner => Upload -> Error');
    }
  };

  const handleSubmit = async data => {
    try {
      // viewLoading();
      const data = {
        catThumbnailSquare: objTemp.catThumbnailSquare,
        catThumbnailBanner: objTemp.catThumbnailBanner,
      };
      console.log(`Data PUT`, data);
      const resPutData = await api(
        'PUT',
        `/catalog/${objData.catId}/image`,
        data
      );
      console.log(resPutData);

      N.success('Successfully updated');

      setTimeout(() => {
        // history.push('/');
        // viewContent();
      }, 1000);
    } catch (error) {
      console.error(error);
      N.error('Error updating');
      // viewContent();
    }
  };

  return (
    <>
      <S.Form onSubmit={handleCheckFiles}>
        <S.DivInput propW="20%">
          <small>
            Square <small>1024px x 1024px</small>
          </small>
          <S.LabelInputImage htmlFor="file-square">
            <img
              src={objTemp.catThumbnailSquare}
              alt="Thumbnail Square"
              onError={() =>
                setTemp(prevState => {
                  return {
                    ...prevState,
                    tmpThumbnailSquare: objDefault.catThumbnailSquare,
                  };
                })
              }
            />
            <input
              id="file-square"
              type="file"
              accept="image/*"
              onChange={e => handleChangeFileSquare(e.target.files)}
            />
          </S.LabelInputImage>
        </S.DivInput>
        <S.DivInput propW="80%">
          <small>
            Banner <small>1980px x 480px</small>
          </small>
          <S.LabelInputImage htmlFor="file-banner">
            <img
              src={objTemp.catThumbnailBanner}
              alt="Thumbnail Banner"
              onError={() =>
                setTemp(prevState => {
                  return {
                    ...prevState,
                    tapThumbnailBanner: objDefault.catThumbnailBanner,
                  };
                })
              }
            />
            <input
              id="file-banner"
              type="file"
              accept="image/*"
              onChange={e => handleChangeFileBanner(e.target.files)}
            />
          </S.LabelInputImage>
        </S.DivInput>
      </S.Form>
      <S.Form onSubmit={handleSubmit}>
        <S.DivButton>
          <ButtonLoader propTitle="SAVE" propSpinner={false} />
        </S.DivButton>
      </S.Form>
      <NotificationContainer />
    </>
  );
};

Image.defaultProps = {
  propData: {},
};

Image.propTypes = {
  propData: PropTypes.object,
};

export default Image;
